<div>
  <div class="loading-spinner" *ngIf="mapUpdating">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </div>

  <div class="toolbar" style="display: flex; flex-wrap: wrap">
    <div style="flex-shrink: 1">
      <app-faceted-filtering-saved-searches
        [selectedFilters]="selectedFilters"
        [definitions]="filterDefinitions"
        (resetFilters)="clearAllFilters()"
        (setSelection)="setFiltersFromLoadedSearch($event)"
      >
      </app-faceted-filtering-saved-searches>
    </div>
    <div *ngIf="settingFilters" style="min-width: 55px; margin-top: 16px">
      <i class="fa fa-spinner fa-spin fa-2x" style="vertical-align: middle"></i>&nbsp;Setting
      filter(s)...
    </div>
    <div style="min-width: 225px; flex-grow: 1">
      <div *ngIf="!isLoading" [ngClass]="showMap ? 'facets-map-icon-hidden' : 'facets-map-icon'">
        <div class="map-hidden-buttons">
          <span>
            <span class="first" style="cursor: pointer; margin-right: 5px"
              >Show Inspection Tasks</span
            >
            <p-inputSwitch
              [styleClass]="'inpswitch'"
              [(ngModel)]="showInspectionTasks"
              (onChange)="onShowInspectionTasksChanged($event)"
            ></p-inputSwitch>
          </span>
          <span
            pTooltip="Selecting this will include cancelled and closed tasks which will be considerably slower"
          >
            <span class="first" style="cursor: pointer; margin-right: 5px">All Jobs</span>
            <p-inputSwitch
              [styleClass]="'inpswitch'"
              [(ngModel)]="showAllJobs"
              (onChange)="onShowAllJobsChanged($event)"
            ></p-inputSwitch>
          </span>
          <button
            icon="fa fa-trash-o"
            type="button"
            (click)="clearAllFilters()"
            label="Clear Filters"
            pButton
          ></button>
          <button
            icon="fa fa-map"
            type="button"
            (click)="toggleMap()"
            label="Show Map"
            pButton
          ></button>
        </div>
      </div>
    </div>
  </div>

  <div class="facets-flex-wrapper">
    <div id="facets-list-container" class="facets-container">
      <div class="facets-inner-container">
        <div id="facetslist" class="facets-list" *ngFor="let filter of filterGroups; let i = index">
          <p-panel
            id="engineius-panel-{{ i }}"
            [pTooltip]="filterDefinitions[i].tooltip"
            tooltipPosition="top"
          >
            <p-header>
              <div class="facet-title-bar">
                <div class="facet-title-text">
                  {{ filter.name }}
                  <span
                    *ngIf="selectedFilters[i] && selectedFilters[i].length > 0"
                    [escape]="false"
                    [tooltipStyleClass]="'xtooltip'"
                    [pTooltip]="getSelectedFiltersString(i)"
                    class="p-badge filters"
                    style="text-align: center; cursor: pointer"
                    >{{ selectedFilters[i].length }}</span
                  >
                </div>

                <div style="flex-grow: 1">
                  <input
                    *ngIf="filterDefinitions[i].searchable"
                    [(ngModel)]="filterDefinitions[i].searchKeyword"
                    autocomplete="off"
                    name="filter"
                    class="filter-input"
                    (input)="applyFilter(i, $event.target.value, 'label', 'contains')"
                  />
                </div>

                <div
                  style="flex-shrink: 1"
                  *ngIf="filterDefinitions[i].searchable"
                  pTooltip="Filter the list by name"
                  class="filter-search-icon"
                >
                  <i class="fa fa-search"></i>
                </div>

                <div style="flex-shrink: 1; white-space: nowrap">
                  <div
                    pTooltip="Switch between alphabetic and 'highest count' ordering"
                    class="filter-sort-icon"
                    (click)="sortFilter(i)"
                  >
                    <i class="fa fa-sort"></i>
                  </div>
                </div>
              </div>
              <div class="select-unselect-layout">
                <p-checkbox
                  class="select-all-white-checkbox"
                  [ngModel]="filter.isSelected"
                  (onChange)="onSelectAllClick(i, $event)"
                  binary="true"
                >
                </p-checkbox>
                <div class="cursor-pointer" (click)="onSelectAllClick(i, !filter.isSelected)">
                  Select All
                </div>
              </div>
            </p-header>

            <p-table
              selectionMode="multiple"
              [(selection)]="selectedFilters[i]"
              [value]="filter.selectItems"
              [lazy]="false"
              (onRowSelect)="filterRowSelectionChanged(i)"
              (onRowUnselect)="filterRowSelectionChanged(i)"
              id="facetTable"
              #facetTable
              [paginator]="false"
              rowHover="true"
              resizableColumns="true"
              [metaKeySelection]="false"
              [style]="{
                height: '295px',
                'overflow-y': 'scroll',
                'border-radius': '0 0 12px 12px'
              }"
              (onFilter)="handleFilter($event, facetTable.totalRecords)"
            >
              <ng-template pTemplate="body" let-item>
                <tr [pSelectableRow]="item" class="no-wrap-cells">
                  <td class="facet-table-cell">
                    <span
                      [ngClass]="{ 'red-label': item?.dataOutOfRange }"
                      appendTo="body"
                      pTooltip="{{ item?.label }}"
                      tooltipPosition="top"
                      >{{ item?.label }}</span
                    >
                  </td>
                  <td style="width: 50px" class="facet-table-cell">
                    <span class="p-badge">{{ item?.count }}</span>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <!-- DATATABLE DEPRECATED --
            <p-dataTabl selectionMode="multiple" [(selection)]="selectedFilters[i]"
                         [value]="filter.selectItems" [lazy]="false" (onRowSelect)="filterRowSelectionChanged(i)"
                         (onRowUnselect)="filterRowSelectionChanged(i)"
                         id="facetTable" #facetTable [immutable]="false"
                         [paginator]="false" rowHover="true" resizableColumns="true"
                         [metaKeySelection]="false"
                         [style]="{'height': '300px', 'overflow-y': 'scroll'}"
                         (onFilter)="handleFilter($event,facetTable.totalRecords)"
            >

              <p-column [editable]="false" field="label">
                <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                  <span [ngClass]="{'red-label': data.dataOutOfRange}" appendTo="body" pTooltip="{{data.label}}"
                        tooltipPosition="top">{{data.label}}</span>
                </ng-template>
              </p-column>
              <p-column [editable]="false">
                <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                  <span class="p-badge">{{data.count}}</span>
                </ng-template>
              </p-column>

            </p-dataTable>
            -->
          </p-panel>
        </div>
      </div>
    </div>

    <!--    <div *ngIf="!isLoading" [ngClass]="showMap ? 'facets-map-icon-hidden' : 'facets-map-icon'">-->
    <!--      <div class="map-hidden-buttons">-->
    <!--        <button class="hidden-map-button" (click)="clearAllFilters();" pTooltip="Clear Inbox Filters"><i-->
    <!--          class="fa fa-trash-o"></i> Clear Selections-->
    <!--        </button>-->
    <!--        <button class="hidden-map-button" (click)="toggleMap();">Show Map</button>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- map view -->
    <div [ngClass]="showMap ? 'facets-map-container' : 'facets-map-container-hidden'">
      <agm-map
        [latitude]="latitude"
        [longitude]="longitude"
        [scrollwheel]="true"
        [zoom]="zoom"
        [minZoom]="5"
        [maxZoom]="15"
        [showDefaultInfoWindow]="false"
        [zoomControl]="false"
        [streetViewControl]="false"
        (mapReady)="agmMapReady($event)"
      >
        <div *ngIf="!showHeatmap">
          <agm-polyline
            *ngFor="let line of polylinePoints"
            [strokeColor]="'#005F8E'"
            [strokeOpacity]="0.5"
            [strokeWeight]="1"
          >
            <agm-icon-sequence
              [fixedRotation]="false"
              [strokeColor]="'#005F8E'"
              [strokeWeight]="2"
              [repeat]="'50px'"
              [offset]="'0%'"
              [path]="'FORWARD_CLOSED_ARROW'"
            >
            </agm-icon-sequence>
            <agm-polyline-point [latitude]="line.lat1" [longitude]="line.lng1">
            </agm-polyline-point>
            <agm-polyline-point [latitude]="line.lat2" [longitude]="line.lng2">
            </agm-polyline-point>
          </agm-polyline>

          <div *ngIf="!selectedJob">
            <agm-marker-cluster
              [gridSize]="30"
              [calculator]="calculateClusterFunction"
              [minimumClusterSize]="1"
              [averageCenter]="true"
              [styles]="pickupIconStyles"
            >
              <agm-marker
                *ngFor="let point of polylinePoints"
                [latitude]="point.lat1"
                [opacity]="0.9"
                [longitude]="point.lng1"
                [markerDraggable]="false"
                [iconUrl]="originIcon"
              >
              </agm-marker>
            </agm-marker-cluster>

            <agm-marker-cluster
              [gridSize]="30"
              [calculator]="calculateClusterFunction"
              [minimumClusterSize]="1"
              [averageCenter]="true"
              [styles]="dropoffIconStyles"
            >
              <agm-marker
                *ngFor="let point of polylinePoints"
                [latitude]="point.lat2"
                icon="red-circle"
                [opacity]="0.9"
                [longitude]="point.lng2"
                [markerDraggable]="false"
                [iconUrl]="destinationIcon"
              >
              </agm-marker>
            </agm-marker-cluster>
          </div>
          <div *ngIf="selectedJob">
            <agm-marker
              *ngFor="let point of polylinePoints"
              [latitude]="point.lat1"
              [opacity]="0.9"
              [longitude]="point.lng1"
              [markerDraggable]="false"
              [iconUrl]="originIcon"
            >
            </agm-marker>
            <agm-marker
              *ngFor="let point of polylinePoints"
              [latitude]="point.lat2"
              icon="red-circle"
              [opacity]="0.9"
              [longitude]="point.lng2"
              [markerDraggable]="false"
              [iconUrl]="destinationIcon"
            >
            </agm-marker>
          </div>
        </div>
        <!--imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m"-->
        <!--<agm-map-directions *ngFor="let task of workingSet" [(origin)]="task.pickupLocation" [(destination)]="task.dropoffLocation">
        </agm-map-directions>-->
      </agm-map>

      <div
        *ngIf="!isLoading"
        [ngClass]="'with-map-clear-filters'"
        pTooltip="Clear Inbox Filters"
        tooltipPosition="left"
      >
        <button class="clear-button" style="width: 130px" (click)="clearAllFilters()">
          <i class="fa fa-trash-o"></i>
          Clear Selections
        </button>
      </div>

      <div
        *ngIf="!isLoading"
        [ngClass]="'with-map-hide-map'"
        pTooltip="Hide Map"
        tooltipPosition="left"
      >
        <button class="map-button" style="width: 30px" (click)="toggleMap()">
          <i class="fa fa-compress"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="results-grid results-list" id="resultslist">
    <p-panel id="resultspanel">
      <p-header>
        <div>
          {{ getResultHeader() }}
          <button
            class="refresh-button"
            type="button"
            (click)="load()"
            pTooltip="Reload Tasks Data From Database"
          >
            <i class="fa fa-refresh clear-button-filter-icon"></i>Refresh Data
          </button>
        </div>
      </p-header>

      <p-table
        id="results-grid"
        selectionMode="single"
        [(selection)]="selectedJob"
        [value]="resultSet"
        [lazy]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [rows]="rowsInPage"
        [responsive]="true"
        [first]="firstRow"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [pageLinks]="8"
        [totalRecords]="workingSet.length"
        (onLazyLoad)="onGridLazyLoad($event)"
        (onRowSelect)="selectedJobChanged($event)"
        (onRowUnselect)="selectedJobChanged($event)"
        [loading]="isLoading"
        [metaKeySelection]="false"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="deployPriorityGrading.description" pResizableColumn>Priority</th>
            <th pSortableColumn="openMessageCount" pResizableColumn>Tags</th>
            <th pSortableColumn="jobNumber" pResizableColumn>Job Number</th>
            <th pSortableColumn="scheduledDate" pResizableColumn>Schedule Date</th>
            <th pSortableColumn="vehicleReg" pResizableColumn>Vehicle Reg</th>
            <th pSortableColumn="from" pResizableColumn>From</th>
            <th pSortableColumn="to" pResizableColumn>To</th>
            <th pSortableColumn="pickupZoneName" pResizableColumn>Collection</th>
            <th pSortableColumn="deliveryZoneName" pResizableColumn>Delivery</th>
            <th pSortableColumn="earliestPickupDate" pResizableColumn>Earliest Pickup</th>
            <th pSortableColumn="earliestDropoffDate" pResizableColumn>Earliest Dropoff</th>
            <th pSortableColumn="customerTaskType" pResizableColumn>Movement Type</th>
            <th pSortableColumn="customerName" pResizableColumn>Customer</th>
            <th pSortableColumn="supplierName" pResizableColumn>Supplier</th>
            <th pSortableColumn="supplierPrice" pResizableColumn>Supplier Price</th>
            <th pSortableColumn="taskStatusName" pResizableColumn>Status</th>
            <th pSortableColumn="inboxTabName" pResizableColumn>Inbox</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr (dblclick)="viewJob(item, $event)" [pSelectableRow]="item" class="no-wrap-cells">
            <td>
              <div class="incident-icons" *ngIf="item.deployPriorityGrading">
                <i
                  [pTooltip]="item.deployPriorityGrading.description"
                  [class]="item.deployPriorityGrading.iconClass"
                  [ngStyle]="{ color: item.deployPriorityGrading.colour }"
                ></i>
              </div>
            </td>
            <td>
              <div class="incident-icons text-center">
                <i
                  *ngIf="rowHasDelayedTask(item)"
                  class="fa fa-flag"
                  style="color: #00a0b4; margin-right: 5px"
                  pTooltip="Customer Update"
                ></i>

                <span *ngIf="item?.classification == 'New'" pTooltip="New Driver">
                  <span class="star">
                    <span class="greenstar" style="width: 16px; height: 16px">
                      <i class="fa fa-star"></i>
                    </span>
                  </span>
                </span>
                <span
                  style="width: 16px; height: 16px; padding-bottom: 20px"
                  *ngIf="item.openMessageCount > 0"
                >
                  <i
                    pTooltip="{{ item.openMessageCount }} Open Incident Messages"
                    class="material-icons"
                    >mail_outline</i
                  >
                </span>
                <span
                  style="width: 16px; height: 16px; padding-bottom: 20px"
                  *ngIf="item.openIncidentCount > 0"
                >
                  <i
                    style="color: #ff8f00"
                    pTooltip="{{ item.openIncidentCount }} Open Incidents"
                    class="material-icons"
                    >report_problem</i
                  >
                </span>
              </div>
            </td>
            <td>
              <span pTooltip="{{ item.jobNumber }}">{{ item.jobNumber }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.scheduledDate | datex : 'ddd DD MMM \'YY' }}">{{
                item.scheduledDate | datex : "ddd DD MMM 'YY"
              }}</span>
            </td>
            <td>
              <span pTooltip="{{ vehicleCountPostfix(item, item.vehicleRegDetails) }}">{{
                vehicleCountPostfix(item, item.vehicleReg)
              }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.from }}" tooltipPosition="left">{{ item.from }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.to }}" tooltipPosition="left">{{ item.to }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.pickupZoneName }}">{{ item.pickupZoneName }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.deliveryZoneName }}">{{ item.deliveryZoneName }}</span>
            </td>
            <td>
              <span
                tooltipStyleClass="ztooltip"
                [escape]="false"
                pTooltip="<div style='padding: 10px; font-size: 13px; line-height: 15px;'><div style='margin-bottom: 7px'>Earliest Pickup:<br/><strong>{{
                  item.earliestPickupDate | datex : 'ddd DD MMM \'YY h:mm a'
                }}</strong></div><div style='margin-bottom: 7px'>Latest Pickup:<br/><strong>{{
                  item.latestPickupDate | datex : 'ddd DD MMM \'YY h:mm a'
                }}</strong></div><div><strong>{{
                  getPickupDropoffDiffHours(item, true)
                }}</strong></div></div>"
              >
                {{ item.earliestPickupDate | datex : "ddd DD MMM 'YY h:mm a" }}
                {{ getPickupDropoffDiffHours(item, true) }}</span
              >
            </td>
            <td>
              <span
                tooltipStyleClass="ztooltip"
                [escape]="false"
                pTooltip="<div style='padding: 10px; font-size: 13px; line-height: 15px;'><div style='margin-bottom: 7px'>Earliest Dropoff:<br/><strong>{{
                  item.earliestDropOffDate | datex : 'ddd DD MMM \'YY h:mm a'
                }}</strong></div><div style='margin-bottom: 7px'>Latest Dropoff:<br/><strong>{{
                  item.latestDropOffDate | datex : 'ddd DD MMM \'YY h:mm a'
                }}</strong></div><div><strong>{{
                  getPickupDropoffDiffHours(item, false)
                }}</strong></div></div>"
              >
                {{ item.earliestDropOffDate | datex : "ddd DD MMM 'YY h:mm a" }}
                {{ getPickupDropoffDiffHours(item, false) }}</span
              >
            </td>
            <td>
              <span pTooltip="{{ item.customerTaskType }}">{{ item.customerTaskType }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.customerName }}">{{ item.customerName }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.supplierName }}">{{ item.supplierName }}</span>
            </td>
            <td>
              <span
                pTooltip="{{ item.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }} {{
                  !item.IsPriceEC ? '' : item.IsPriceEC == true ? 'EC' : 'BIN'
                }}"
              >
                {{ item.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                {{ !item.IsPriceEC ? '' : item.IsPriceEC == true ? 'EC' : 'BIN' }}</span
              >
            </td>
            <td>
              <span pTooltip="{{ item.taskStatusName }}">{{ item.taskStatusName }}</span>
            </td>
            <td>
              <span pTooltip="{{ item.inboxTabName }}">{{ item.inboxTabName }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!----
      <p-dataTabl id="results-grid" selectionMode="single" [(selection)]="selectedJob"
                   [value]="resultSet" [lazy]="true"
                   [paginator]="true" rowHover="true" resizableColumns="true"
                   [rows]="rowsInPage" [responsive]="true" [first]="firstRow"
                   [rowsPerPageOptions]="[10,20,50,100]" [pageLinks]="8" [totalRecords]="workingSet.length"
                   (onLazyLoad)="onGridLazyLoad($event)" (onRowDblclick)="viewJob($event)"
                   (onRowSelect)="selectedJobChanged($event)" (onRowUnselect)="selectedJobChanged($event)"
                   [loading]="isLoading" [metaKeySelection]="false">


        <p-column field="Priority" [style]="{'width':'30px'}" [sortable]="true" [frozen]="true">
          <ng-template let-row="rowData" let-index="rowIndex" let-col pTemplate="body">
            <div class="incident-icons" *ngIf="row.deployPriorityGrading">
              <i [pTooltip]="row.deployPriorityGrading.description" [class]="row.deployPriorityGrading.iconClass" [ngStyle]="{ color: row.deployPriorityGrading.colour }"></i>
            </div>
          </ng-template>
        </p-column>

        <p-column  [resizable]="false" [editable]="false" field="icon"
                  styleClass="align-center" [style]="{'width': '30px', 'padding': '0px'}" [sortable]="true">
          <ng-template let-item="rowData" pTemplate="body">
            <div class="incident-icons">
              <i *ngIf="item.openMessageCount > 0" pTooltip="{{ item.openMessageCount }} Open Incident Messages" class="material-icons">mail_outline</i>
              <i *ngIf="item.openIncidentCount > 0" style="color: #FF8F00;" pTooltip="{{ item.openIncidentCount }} Open Incidents" class="material-icons">report_problem</i>
            </div>
          </ng-template>
        </p-column>

        <p-column [editable]="false" [sortable]="true" header="Job Number" field="jobNumber">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span pTooltip="{{data.jobNumber}}">{{data.jobNumber}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Scheduled Date" field="scheduledDate">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span
              pTooltip="{{data.scheduledDate  | datex:'ddd DD MMM \'YY'}}">{{data.scheduledDate | datex:'ddd DD MMM \'YY'}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Vehicle Reg" field="vehicleReg">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span
              pTooltip="{{vehicleCountPostfix(data, data.vehicleRegDetails)}}">{{vehicleCountPostfix(data, data.vehicleReg)}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="From" field="from">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span pTooltip="{{data.from}}" tooltipPosition="left">{{data.from}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="To" field="to">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span pTooltip="{{data.to}}" tooltipPosition="left">{{data.to}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Collection" field="pickupZoneName">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span pTooltip="{{data.pickupZoneName}}">{{data.pickupZoneName}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Delivery" field="deliveryZoneName">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span pTooltip="{{data.deliveryZoneName}}">{{data.deliveryZoneName}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Earliest Pickup" field="earliestPickupDate">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                        <span
                          tooltipStyleClass='ztooltip'
                          [escape]="false"
                          pTooltip="<div style='padding: 10px; font-size: 13px; line-height: 15px;'><div style='margin-bottom: 7px'>Earliest Pickup:<br/><strong>{{data.earliestPickupDate | datex:'ddd DD MMM \'YY h:mm a'}}</strong></div><div style='margin-bottom: 7px'>Latest Pickup:<br/><strong>{{data.latestPickupDate | datex:'ddd DD MMM \'YY h:mm a'}}</strong></div><div><strong>{{ getPickupDropoffDiffHours(data, true) }}</strong></div></div>">
                        {{data.earliestPickupDate | datex:'ddd DD MMM \'YY h:mm a'}} {{ getPickupDropoffDiffHours(data, true) }}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Earliest Dropoff" field="earliestDropOffDate">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                        <span
                          tooltipStyleClass='ztooltip'
                          [escape]="false"
                          pTooltip="<div style='padding: 10px; font-size: 13px; line-height: 15px;'><div style='margin-bottom: 7px'>Earliest Dropoff:<br/><strong>{{data.earliestDropOffDate | datex:'ddd DD MMM \'YY h:mm a'}}</strong></div><div style='margin-bottom: 7px'>Latest Dropoff:<br/><strong>{{data.latestDropOffDate | datex:'ddd DD MMM \'YY h:mm a'}}</strong></div><div><strong>{{ getPickupDropoffDiffHours(data, false) }}</strong></div></div>">
                        {{data.earliestDropOffDate | datex:'ddd DD MMM \'YY h:mm a'}} {{ getPickupDropoffDiffHours(data, false) }}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Move Type" field="customerTaskType">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span pTooltip="{{data.customerTaskType}}">{{data.customerTaskType}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Customer" field="customerName">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span pTooltip="{{data.customerName}}">{{data.customerName}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Supplier" field="supplierName">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span pTooltip="{{data.supplierName}}">{{data.supplierName}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Supplier Price" field="supplierPrice">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                        <span
                          pTooltip="{{data.supplierPrice | currency:'GBP':'symbol':'1.2-2'}} {{!data.IsPriceEC ? '' : (data.IsPriceEC == true ? 'EC' : 'BIN')}}">
                        {{data.supplierPrice | currency:'GBP':'symbol':'1.2-2'}} {{!data.IsPriceEC ? '' : (data.IsPriceEC == true ? 'EC' : 'BIN')}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Status" field="jobStatus">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span pTooltip="{{data.jobStatus}}">{{data.jobStatus}}</span>
          </ng-template>
        </p-column>
        <p-column [editable]="false" [sortable]="true" header="Inbox" field="inboxTabName">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span pTooltip="{{data.inboxTabName}}">{{data.inboxTabName}}</span>
          </ng-template>
        </p-column>
      </p-dataTable>
      -->
    </p-panel>
  </div>

  <div class="footerPanel ui-grid-row">
    <button
      class="pull-right ui-sm-12 mt-1"
      type="button"
      (click)="markPriority()"
      icon="fa fa-thumb-tack"
      label="Mark/Unmark for Priority Deployment"
      pButton
      [disabled]="!selectedJob || selectedJob.inboxTabName != 'Job Deployment'"
    ></button>

    <button
      class="pull-right ui-sm-12 mt-1"
      type="button"
      (click)="supplierSchedule()"
      icon="fa fa-calendar"
      label="Supplier Schedule"
      pButton
      [disabled]="!selectedJob || selectedJob.inboxTabName != 'Job Deployment'"
    ></button>

    <button
      class="pull-right ui-sm-12 mt-1"
      type="button"
      [appOpenUrl]="'/app/job-deployment/' + selectedJob?.jobId"
      icon="fa fa-user-plus"
      label="Job Deployment"
      pButton
      [disabled]="!selectedJob || selectedJob.inboxTabName != 'Job Deployment'"
    ></button>

    <button
      class="pull-right ui-sm-12 mt-1"
      type="button"
      (click)="markJobForCombine()"
      icon="fa fa-thumb-tack"
      label="Mark For Combine"
      pButton
      [disabled]="!selectedJob || selectedJob.inboxTabName != 'Job Deployment'"
    ></button>
    <button
      class="pull-right ui-sm-12 mt-1"
      type="button"
      icon="fa fa-cloud-download"
      (click)="downloadToCSV()"
      label="Download to CSV"
      pButton
    ></button>
  </div>
</div>
